<template>
  <router-view/>
</template>

<style lang="sass">
.markdown-textview
  ul,
  ol
    margin-bottom: 16px
</style>
<script>
import Axios from '@/helpers/axios';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'App',
  components: {
  },
  beforeMount() {
    this.$router.onReady(() => {
      this.login();
    });
  },
  computed: {
    ...mapState([
      'client',
      'user',
    ]),
  },
  methods: {
    ...mapMutations([
      'setDtk',
      'setUtk',
      'setLactk',
      'setLtk',
      'SET_USER',
      'RESET_CART',
      'REMOVE_FROM_SAVED_ORDERS',
    ]),
    login() {
      if (!this.$route.params.brandId) {
        this.showLoader = false;
        return;
      }
      const data = {
        ...this.$route.query,
        brandId: this.$route.params.brandId,
      };
      Axios({
        method: 'post',
        url: '/panel',
        data,
      })
        .then((response) => {
          this.SET_USER(response.data);
          this.showLoader = false;
        });
    },
  },
};
</script>

<style lang="sass">
@import url('//fonts.googleapis.com/css2?family=Montserrat:wght@300;500;600&family=Noto+Sans+TC:wght@400;700&family=Space+Mono&display=swap')
@import url('//fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Round')
// Bootstrap

html,
body,
#app
  width: 100%
  height: 100%

  font-family: 'Montserrat','PingFangTC-Regular', 'PingFangHK-Regular', 'PingFangSC-Regular', 'Noto Sans TC', sans-serif
  color: $color-dark
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale

.section-title
  @extend .MB-s
  @extend .PR-m
  @extend .PL-m
  @extend .FW-b
  @extend .FZ-16
  @extend .LH-140

  letter-spacing: 1.5px

.section-sub-title
  @extend .MB-s
  @extend .PR-m
  @extend .PL-m
  @extend .FZ-14
  @extend .LH-140
  @extend .C-grey

.icon-button
  display: flex

  .icon
    @extend .MR-s

  .label
    flex-grow: 1
    @extend .PR-xl

.el-message
  top: 75% !important
  max-width: 80%
  min-width: auto
  padding: 12px 15px
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12)

  border-color: transparent
  border-radius: 10px

  &--success
    background-color: white

    font-weight: bold

    .el-message__content
      color: inherit

  &--error
    background-color: $color-notice

    .el-message__content
      color: white

  .el-message__content
    font-weight: bold

  .el-message__icon
    display: none

@keyframes showSweetAlert
  0%
    opacity: 0
    transform: scale(.75)

  100%
    opacity: 1
    transform: scale(1)

.swal2
  &-container
    &.swal2-backdrop-show
      background: rgba(0, 0, 0, .75) !important

  &-popup
    padding: 0 !important

    border-radius: $size-m !important

    background-color: #111 !important

    color: white !important

    &.swal2-show
      animation: showSweetAlert .25s $cb !important

    .swal2-content
      width: 100% !important
      padding: 32px 24px 16px !important
      margin: 0 !important

      font-size: 16px !important
      font-weight: bold !important
      color: white !important
      text-align: left !important
      white-space: pre-wrap !important

    .swal2-actions
      justify-content: flex-end !important
      padding: 8px 8px 8px 24px !important
      margin: 0 !important

    .swal2-styled
      &.swal2-confirm,
      &.swal2-cancel
        margin: 0 !important
        padding: 16px !important

        border-radius: 0 !important

        background: none !important

        font-size: 14px !important
        font-weight: 700 !important
        color: #ffea00 !important

        outline: none !important
        appearance: none !important

        &:focus
          box-shadow: none !important

        &:hover,
        &:active
          color: #ffea00 !important

          outline: none !important
          transform: scale(.95) !important

      &.swal2-cancel
        color: #656565 !important

input[type=search]::-webkit-search-cancel-button
  display: none

.grecaptcha-badge
  display: none !important

</style>
